import { AfterViewInit, Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import {isNullOrUndefined} from 'util';

@Directive({
    selector: '[trim]',
})
export class TrimDirective implements AfterViewInit {

    @Input() trimLength: number = 160;
    @Input() showMoreButton: boolean = false;

    private nativeElement: Node;
    private showText = "Pokaż cały opis";
    private hideText = "Ukryj opis";
    private anchor;
    private showFullText: boolean = false;
    private fullText: string;
    private shortText: string;

    constructor(
        private renderer: Renderer2,
        private element: ElementRef
    ) {

    }

    ngAfterViewInit() {
        this.nativeElement = this.element.nativeElement;
        this.fullText = this.nativeElement.textContent;
        this.shortText = this.nativeElement.textContent;
        if(this.fullText.length > this.trimLength) {
            this.shortText = this.shortText.substr(0, this.trimLength) + '... ';
            this.nativeElement.textContent = this.shortText;
            if (this.showMoreButton) {
                this.anchor = this.renderer.createElement('a');
                this.anchor.textContent = this.showText;
                this.renderer.listen(this.anchor, 'click', () => this.toggleText());
                this.renderer.appendChild(this.nativeElement, this.anchor);
                this.renderer.nextSibling(this.nativeElement)
            }
        }

    }

    private toggleText() {
        this.showFullText = !this.showFullText;
        if(this.showFullText) {
            this.nativeElement.textContent = this.fullText;
        } else {
            this.nativeElement.textContent = this.shortText;
        }
        this.renderer.appendChild(this.nativeElement, this.anchor);
        this.renderer.nextSibling(this.nativeElement);
        this.toggleTriggerText(this.showFullText);
    }

    private toggleTriggerText(show: boolean) {
        if(!show) {
            this.anchor.textContent = this.showText;
        } else {
            this.anchor.textContent = this.hideText;
        }
    }
}
